import React from "react";
import { MenuItens } from "../../types";
import {
  AppBar,
  Drawer,
  Grid2,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  List,
  ListItemIcon,
  Box,
  Toolbar,
} from "@mui/material";
import { useNavigate } from "react-router";
import MenuIcon from "@mui/icons-material/Menu";
import { UserMenu } from "./user-menu.component";

interface CDrawnerMobileProps {
  open?: boolean;
  data?: MenuItens[];
  children: React.ReactNode;
}

export const CDrawnerMobile = React.memo(
  ({ data, children }: CDrawnerMobileProps) => {
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();

    const handleDrawerOpen = () => {
      setOpen(true);
    };

    const handleDrawerClose = () => {
      setOpen(false);
    };
    return (
      <>
        <AppBar position="fixed">
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={[
                {
                  marginRight: 5,
                },
                open && { display: "none" },
              ]}
            >
              <MenuIcon />
            </IconButton>
            <Grid2
              container
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: "100%" }}
            >
              <Grid2>
                <Typography variant="h6" noWrap component="div">
                  Bellatchau
                </Typography>
              </Grid2>
              <Grid2>
                <UserMenu />
              </Grid2>
            </Grid2>
          </Toolbar>
        </AppBar>
        <Drawer open={open} onClose={handleDrawerClose}>
          <List>
            {data?.map((item, index) => (
              <ListItem
                key={item.name}
                disablePadding
                sx={{ display: "block" }}
              >
                <ListItemButton
                  sx={[
                    {
                      minHeight: 48,
                      px: 2.5,
                    },
                    open
                      ? {
                          justifyContent: "initial",
                        }
                      : {
                          justifyContent: "center",
                        },
                  ]}
                  onClick={() => navigate(item.route)}
                >
                  <ListItemIcon
                    sx={[
                      {
                        minWidth: 0,
                        justifyContent: "center",
                      },
                      open
                        ? {
                            mr: 3,
                          }
                        : {
                            mr: "auto",
                          },
                    ]}
                    onClick={() => navigate(item.route)}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.name}
                    sx={[
                      open
                        ? {
                            opacity: 1,
                          }
                        : {
                            opacity: 0,
                          },
                    ]}
                    onClick={() => navigate(item.route)}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
        <Box component="main" sx={{ p: 3, mt: 7 }}>
          {children}
        </Box>
      </>
    );
  }
);
